import axios from "axios";
import { useMeStore } from "@/stores/me";

export default {
  async saveLinkDefaultViewType({ commit }, defaultViewType) {
    const meStore = useMeStore();
    const userId = meStore.userId;

    await axios.post(
      `https://skobostats.azurewebsites.net/api/UserSettings?code=TCsYhdXzGIodM/bwslBH/eCvoW4vO0He3HHzwBkmlrSk1r29clZJzQ==`,
      { key: "linkDefaultViewType", value: defaultViewType, userId }
    );
    commit("saveLinkDefaultViewType", defaultViewType);
  }
};
